import { createSelector } from 'reselect'
import { Report } from './types'

const getVirtualEventsReport = (type: string, state: Report) => state.virtualEventsReport && state.virtualEventsReport[type] ? state.virtualEventsReport[type] : null

/** A Redux selector to retrieve Report ID
 * @param state - The Redux state
 * @param {String} - The Report ID
 */

export const selectVirtualEventsReportId = createSelector(
  getVirtualEventsReport,
  (data) => data && data.reportId ? data.reportId : null
)

/** A Redux selector to retrieve In-Progress state
 * @param state - The Redux state
 * @param {Boolean} - In Progress state
 */

export const selectVirtualEventsReportInProgress = createSelector(
  getVirtualEventsReport,
  (data) => data && data.inProgress ? data.inProgress : false
)

/** A Redux selector to retrieve Is-Generating state
 * @param state - The Redux state
 * @param {Boolean} - Is Generating state
 */

export const selectVirtualEventsReportIsGenerating = createSelector(
  getVirtualEventsReport,
  (data) => data && data.isGenerating ? data.isGenerating : false
)

/** A Redux selector to retrieve Report URL
 * @param state - The Redux state
 * @param {string} - Report URL
 */

export const selectVirtualEventsReportURL = createSelector(
  getVirtualEventsReport,
  (data) => data && data.reportUrl ? data.reportUrl : null
)

/** A Redux selector to retrieve Cancellation Status
 * @param state - The Redux state
 * @param {Boolean} - Cancelled
 */

export const selectVirtualEventsReportCancelStatus = createSelector(
  getVirtualEventsReport,
  (data) => data && data.cancelled ? data.cancelled : false
)

/** A Redux selector to retrieve Report Error
 * @param state - The Redux state
 * @param {String} - ERROR
 */

export const selectVirtualEventsReportGenerationError = createSelector(
  getVirtualEventsReport,
  (data) => data && data.error ? data.error : false
)